<template>
  <div :style="themeStyle">
    <v-row class="headline1_bg p-3" no-gutters>
      <v-col cols="12" :style="'color: ' + (isTargetShop ? '#000' : $textcolor)">
        <div @click="$router.go(-1)" :style="isTargetShop ? 'font-size: 20px;' : ''"> <v-icon>mdi-chevron-left</v-icon>
          {{ isTargetShop ? $t("message.reward") : $t("message.promotion") }}</div>
      </v-col>
    </v-row>
    <div class="pl-0 pr-0 pt-0">

      <v-row>
        <v-col class=" font16 text-center pt-10 pb-2" :style="$isTargetShop ? 'font-size: 20px;font-weight: 100 !important;' : 'font-weight: bold;'">{{ $t("message.mypoint") }}</v-col>
      </v-row>
      <v-row v-if="member">
        <v-col class=" font45 weight1000 text-center pa-0" v-if="member.currentPoint > 0">
          {{ formatNumber(member.currentPoint) }}
          <img v-if="profile.pictureUrl && !$isTargetShop()" style="
                    border-color: white;
                    height: 30px;
                    margin-left:7px;
                  " alt="Avatar" :src="require('@/assets/coin.png')" />
          <img v-else style="
                  border-color: white;
                  height: 30px;
                  margin-right: 4px;
                " alt="Avatar" :src="$images.point" />
        </v-col>
        <v-col class=" font45 weight1000 text-center pa-0" v-if="member.currentPoint === 0">
          {{ member.currentPoint }}
          <img v-if="profile.pictureUrl && !$isTargetShop()" style="
                    border-color: white;
                    height: 30px;
                    margin-left:7px;
                  " alt="Avatar" :src="require('@/assets/coin.png')" />
          <img v-else style="
                  border-color: white;
                  height: 30px;
                  margin-right: 4px;
                " alt="Avatar" :src="$images.point" />
        </v-col>
      </v-row>
      <!-- <v-row>
          <v-col class="ml-1 mr-1">
            <v-card style="border-radius: 20px" class="pa-3 pt-2">
              <v-select
                class="pt-0"
                :items="levelName"
                v-model="value"
                menu-props="auto"
                label="Select Level"
                hide-details
                prepend-icon="mdi-magnify"
                single-line
                clearable
                @change="search(value)"
              ></v-select>
              </v-card>
          </v-col>
        </v-row> -->
      <div v-show="value !== null">
        <SearchReward ref="modal1" />
      </div>
      <!-- <special-offer v-if="value === null"/><br> -->
      <all-rewards v-if="value === null" />
      <!-- <all-reward-trending v-if="value === null"/> -->
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import AllRewards from './AllRewards'
import SpecialOffer from '../../SpecialOffer'
import AllRewardTrending from '../../AllRewardTrending'
import SearchReward from './SearchReward'

export default {
  name: 'Reward',
  components: {
    'all-rewards': AllRewards,
    'special-offer': SpecialOffer,
    'all-reward-trending': AllRewardTrending,
    SearchReward
  },
  data () {
    return {
      member: null,
      profile: null,
      value: null,
      levelName: []
    }
  },
  computed: {
    isTargetShop () {
      try {
        return this.$isTargetShop()
      } catch (e) {
        return false
      }
    }
  },
  async mounted () {
    this.member = await this.GET_MEMBERINFO()
    this.profile = await this.getLiffProfile()
    await this.getReward()
    await this.getLevelDB()
  },
  methods: {
    ...mapGetters('lineStore', ['liffIsReady', 'getLiffProfile']),
    ...mapGetters('memberStore', ['GET_MEMBERINFO']),

    async getReward () {
      const result = await this.callBeTaskAPI('get', '/reward/line/get?RECORD_STATUS=N&quota=0')
      if (result) {
        this.items = result
      }
    },
    async getLevelDB () {
      const result = await this.callBeTaskAPI('get', '/level/line/get?RECORD_STATUS=N')
      if (result) {
        if (result.length > 0) {
          this.level = result.sort((a, b) => {
            if (a.point < b.point) { return -1 } else if (a.point > b.point) { return 1 } else { return 0 }
          })
          this.level.map(item => this.levelName.push(item.name))
        }
      }
    },
    search (items) {
      this.$refs.modal1.getSerach(items)
      // console.log(items)
    }
  }
}
</script>
<style scoped>
.v-slide-group__wrapper {
  touch-action: auto !important;
}

.headline1_bg {
  background-color: #FFA300 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/HomeCUSTOM/Reward/Reward.vue